export interface ManageMenuItem {
  key: string;
  label: string;
  route?: string;
  action?: 'card_modal' | 'card_modal_new_task' | 'card_modal_new_update';
}

export const MANAGE_MENU_ITEMS: ManageMenuItem[] = [
  { key: 'acessar', label: 'Acessar Gestão IA', route: '/gestao_ia' },
  { key: 'trabalhar', label: 'Trabalhar na licitação', action: 'card_modal' },
  { key: 'tarefa', label: 'Adicionar tarefa', action: 'card_modal_new_task' },
  { key: 'atualizacao', label: 'Adicionar atualização', action: 'card_modal_new_update' },
  { key: 'arquivar', label: 'Arquivar licitação' },
];
